<div class="controls">
  <button class="basic-ps-button" (click)="callFeasibility()">
    Call Feasibility
  </button>
  <label>
    Payload:
    <input type="text" [(ngModel)]="payload" />
  </label>

  <svg
    *ngIf="loading"
    style="width: 30px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
  >
    <path
      fill="#4A91C5"
      stroke="#4A91C5"
      stroke-width="15"
      transform-origin="center"
      d="m148 84.7 13.8-8-10-17.3-13.8 8a50 50 0 0 0-27.4-15.9v-16h-20v16A50 50 0 0 0 63 67.4l-13.8-8-10 17.3 13.8 8a50 50 0 0 0 0 31.7l-13.8 8 10 17.3 13.8-8a50 50 0 0 0 27.5 15.9v16h20v-16a50 50 0 0 0 27.4-15.9l13.8 8 10-17.3-13.8-8a50 50 0 0 0 0-31.7Zm-47.5 50.8a35 35 0 1 1 0-70 35 35 0 0 1 0 70Z"
    >
      <animateTransform
        type="rotate"
        attributeName="transform"
        calcMode="spline"
        dur="2"
        values="0;120"
        keyTimes="0;1"
        keySplines="0 0 1 1"
        repeatCount="indefinite"
      ></animateTransform>
    </path>
  </svg>
  <p *ngIf="error !== ''" style="color: red">{{ error }}</p>
</div>

<!-- Tabs -->
<div class="tabs" role="tablist" aria-label="Feasibility views">
  <button
    role="tab"
    [attr.aria-selected]="activeTab === 'overview'"
    class="tab-btn"
    [class.active]="activeTab === 'overview'"
    (click)="setTab('overview')"
  >
    Overview
  </button>

  <button
    role="tab"
    [attr.aria-selected]="activeTab === 'group-quotas'"
    class="tab-btn"
    [class.active]="activeTab === 'group-quotas'"
    (click)="setTab('group-quotas')"
  >
    Group Quotas
  </button>

  <button
    role="tab"
    [attr.aria-selected]="activeTab === 'suppliers'"
    class="tab-btn"
    [class.active]="activeTab === 'suppliers'"
    (click)="setTab('suppliers')"
  >
    Suppliers
  </button>

  <button
    role="tab"
    [attr.aria-selected]="activeTab === 'deviation'"
    class="tab-btn"
    [class.active]="activeTab === 'deviation'"
    (click)="setTab('deviation')"
  >
    Deviation
  </button>
  <button
    role="tab"
    [attr.aria-selected]="activeTab === 'quotas'"
    class="tab-btn"
    [class.active]="activeTab === 'quotas'"
    (click)="setTab('quotas')"
  >
    Quotas
  </button>
  <button
    role="tab"
    [attr.aria-selected]="activeTab === 'redistributionAdditions'"
    class="tab-btn"
    [class.active]="activeTab === 'redistributionAdditions'"
    (click)="setTab('redistributionAdditions')"
  >
    Redistribution Additions
  </button>

  <button
    role="tab"
    [attr.aria-selected]="activeTab === 'raw'"
    class="tab-btn"
    [class.active]="activeTab === 'raw'"
    (click)="setTab('raw')"
  >
    Raw JSON
  </button>
</div>

<!-- Panels -->
<div class="tab-panel" *ngIf="activeTab === 'overview'" role="tabpanel">
  <h3>Overview</h3>
  <p>USE CASE: {{ use_case }}</p>
  <p>TOTAL FEASIBILITY: {{ total_feasibility }}</p>
</div>

<div class="tab-panel" *ngIf="activeTab === 'group-quotas'" role="tabpanel">
  <h3>Group Quotas</h3>
  <div class="group-list">
    <div *ngFor="let groupQuota of group_counts" class="group-item">
      <div class="group-title">
        Group Quota ID (Qualification): {{ groupQuota.key }}
      </div>
      <div>Total Group Quota Feasibility: {{ groupQuota.count }}</div>
      <div>Factor: {{ getGroupFactor(groupQuota.key) }}</div>
      <div *ngIf="groupQuota.suppliers">
        <strong>Suppliers</strong>
        <ul>
          <li *ngFor="let s of groupQuota.suppliers">
            <div style="display: flex; align-items: center; gap: 8px">
              <button class="link-btn" (click)="toggleSupplierDetails(s)">
                Supplier {{ s.supplier_id }}: {{ s.count }}
              </button>
            </div>

            <div class="group-details" *ngIf="isExpanded(getSupplierId(s))">
              <div
                class="details"
                style="display: flex; flex-direction: column; gap: 6px"
              >
                <div *ngIf="supplierDetails[getSupplierId(s)]?.suppFeas">
                  <div>
                    <strong>Mutipliacation of Factors:</strong>
                    Round this value down:
                    <div>Supplier Factor * Group Quota Factor</div>
                    <div>
                      <button class="link-btn" (click)="setTab('suppliers')">
                        {{
                          supplierDetails[getSupplierId(s)].factorEntry.factor
                        }}</button
                      >* {{ getGroupFactor(groupQuota.key) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="tab-panel" *ngIf="activeTab === 'suppliers'" role="tabpanel">
  <h3>Suppliers</h3>
  <div
    *ngIf="
      (supplier_factor && supplier_factor.length) ||
      (response.suppliers && response.suppliers.length)
    "
  >
    <table class="suppliers-table">
      <thead>
        <tr>
          <th>Supplier ID</th>
          <th>Factor</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let supplier of supplier_factor">
          <tr>
            <td>{{ supplier.supplier_id || supplier.id }}</td>
            <td>
              <button
                class="link-btn"
                (click)="toggleSupplierDetails(supplier)"
              >
                {{ supplier.factor }}
              </button>
            </td>
          </tr>
          <tr class="details-row" *ngIf="isExpanded(getSupplierId(supplier))">
            <td colspan="2">
              <div class="details">
                <div style="display: flex; flex-direction: column">
                  <div>
                    Desktop:
                    {{
                      supplierDetails[getSupplierId(supplier)].suppFeas
                        .desktopMonthlyActUsr
                    }}
                  </div>
                  <div>
                    Mobile:
                    {{
                      supplierDetails[getSupplierId(supplier)].suppFeas
                        .mobileMonthlyActUsr
                    }}
                  </div>
                  <div>
                    Multiplier:
                    {{
                      supplierDetails[getSupplierId(supplier)].suppFeas
                        .patnrDelvryMulplr
                    }}
                  </div>
                  <div>
                    ( Desktop (If the Device is in the survey) + Mobile (If the
                    Device is in the survey) ) * Multiplier = Factor
                  </div>
                  <div>
                    ({{
                      supplierDetails[getSupplierId(supplier)].suppFeas
                        .desktopMonthlyActUsr
                    }}
                    +
                    {{
                      supplierDetails[getSupplierId(supplier)].suppFeas
                        .mobileMonthlyActUsr
                    }}
                    ) *
                    {{
                      supplierDetails[getSupplierId(supplier)].suppFeas
                        .patnrDelvryMulplr
                    }}
                  </div>
                  <div>Factor: {{ supplier.factor }}</div>
                  <div>
                    OBS: If you remove Or Mobile or Desktop this calculations is
                    not going to match, you have to remove the "Devices" when
                    you sum them in ( Desktop + Mobile ) .
                  </div>
                </div>

                <p><strong>Factor entry:</strong> {{ supplier | json }}</p>
                <p *ngIf="supplierDetails[getSupplierId(supplier)]?.countEntry">
                  <strong>Count entry:</strong>
                  {{
                    supplierDetails[getSupplierId(supplier)].countEntry | json
                  }}
                </p>
                <p
                  *ngIf="supplierDetails[getSupplierId(supplier)]?.metaSupplier"
                >
                  <strong>Meta supplier:</strong>
                  {{
                    supplierDetails[getSupplierId(supplier)].metaSupplier | json
                  }}
                </p>
                <p *ngIf="supplierDetails[getSupplierId(supplier)]?.suppFeas">
                  <strong>SuppFeas:</strong>
                  {{ supplierDetails[getSupplierId(supplier)].suppFeas | json }}
                </p>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div *ngIf="!response.suppliers || !response.suppliers.length">
    No supplier data
  </div>
</div>

<div class="tab-panel" *ngIf="activeTab === 'deviation'" role="tabpanel">
  <h3>Deviation</h3>
  <div *ngIf="deviation && deviation.daviationConfigSettings">
    <section class="deviation-config">
      <h4>Global Config Settings</h4>
      <div>
        <p>
          Standard Deviation 1:
          {{ deviation?.daviationConfigSettings?.standardDeviation1 }}
        </p>
        <p>
          Standard Deviation 2:
          {{ deviation?.daviationConfigSettings?.standardDeviation2 }}
        </p>
        <p>
          Standard Deviation 3:
          {{ deviation?.daviationConfigSettings?.standardDeviation3 }}
        </p>
        <p>
          Reduction Cap: {{ deviation?.daviationConfigSettings?.reductionCap }}
        </p>
      </div>
    </section>

    <section class="deviation-values">
      <p><strong>IR:</strong> {{ deviation?.ir }}</p>
      <p><strong>LOI:</strong> {{ deviation?.loi }}</p>
      <p>
        <strong>Price Override BCPI:</strong> {{ deviation?.priceOverrideBCPI }}
      </p>
      <p>
        <strong>Price Override SCPI:</strong> {{ deviation?.priceOverrideSCPI }}
      </p>
      <p><strong>Pure Price SCPI:</strong> {{ deviation?.purePriceSCPI }}</p>
      <p><strong>SCPI Differences:</strong> {{ deviation?.scpiDifferences }}</p>
      <p>
        <strong>Standard Deviation:</strong> {{ deviation?.standardDeviation }}
      </p>
      <p><strong>Deviation (numeric):</strong> {{ deviation?.deviation }}</p>
    </section>

    <section class="deviation-impact">
      <h4>Feasibility Impact</h4>
      <pre>{{ deviation?.feasibilityImpact }}</pre>
    </section>
  </div>
  <div *ngIf="!deviation">Deviation was not applied</div>
</div>

<div class="tab-panel" *ngIf="activeTab === 'quotas'" role="tabpanel">
  <h3>Quotas</h3>
  <div
    class="quota-grid"
    style="
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 12px;
      margin-top: 12px;
    "
  >
    <ng-container *ngFor="let quota of quota_list">
      <article
        class="quota-card"
        role="group"
        style="
          border: 1px solid #e6e6e6;
          padding: 12px;
          border-radius: 6px;
          background: #fff;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        "
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
          "
        >
          <div style="font-weight: 600">
            Quota ID: <span style="font-weight: 700">{{ quota.quota_id }}</span>
          </div>
          <div style="text-align: right">
            <div style="font-size: 0.85rem; color: #666">Quota Factor</div>
            <div style="font-weight: 700; color: #0b5ed7">
              {{ quota.factor }}
            </div>
          </div>
        </div>

        <dl
          style="
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 6px 12px;
            margin: 0 0 8px 0;
          "
        >
          <div>
            <dt style="font-weight: 600; font-size: 0.85rem; color: #444">
              Field time multiplier
            </dt>
            <dd style="margin: 0">{{ quota.survey_field_time_multiplier }}</dd>
          </div>
          <div>
            <dt style="font-weight: 600; font-size: 0.85rem; color: #444">
              Criteria % sum
            </dt>
            <dd style="margin: 0">{{ quota.perc }}</dd>
          </div>
          <div>
            <dt style="font-weight: 600; font-size: 0.85rem; color: #444">
              IR factor
            </dt>
            <dd style="margin: 0">{{ quota.ir_factor }}</dd>
          </div>
          <div>
            <dt style="font-weight: 600; font-size: 0.85rem; color: #444">
              Deviation
            </dt>
            <dd style="margin: 0">{{ quota.deviation }}</dd>
          </div>
          <div>
            <dt style="font-weight: 600; font-size: 0.85rem; color: #444">
              Quota Type
            </dt>
            <dd style="margin: 0">{{ quota.quota_type }}</dd>
          </div>
        </dl>

        <div style="font-size: 0.9rem; color: #333; margin-bottom: 8px">
          <div style="font-weight: 600; margin-bottom: 6px">
            Quota Factor Calculation
          </div>
          <div
            style="
              font-family: monospace;
              background: #f7f7f7;
              padding: 8px;
              border-radius: 4px;
            "
          >
            Field Time Multiplier * Quota Criteria Percentage Sum * Incidence
            Rate Factor * (1 - Deviation)
            <div style="margin-top: 6px">
              {{ quota.survey_field_time_multiplier }} * {{ quota.perc }} *
              {{ quota.ir_factor }} * (1 - {{ quota.deviation }})
            </div>
          </div>
        </div>

        <details>
          <summary style="cursor: pointer; font-weight: 600">
            Suppliers
            <span *ngIf="quota.suppliers?.length"
              >({{ quota.suppliers.length }})</span
            >
          </summary>
          <div style="margin-top: 8px">
            <table
              style="width: 100%; border-collapse: collapse; font-size: 0.9rem"
            >
              <thead>
                <tr style="text-align: left; color: #666; font-size: 0.8rem">
                  <th style="padding: 6px 8px">Supplier ID</th>
                  <th style="padding: 6px 8px">Count</th>
                  <th style="padding: 6px 8px">Additional Redistribution?</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let s of quota.suppliers || []"
                  style="border-top: 1px solid #eee"
                >
                  <td style="padding: 6px 8px">{{ s.supplier_id }}</td>
                  <td style="padding: 6px 8px">{{ s.count }}</td>
                  <td style="padding: 6px 8px">
                    {{ isSupplierGotExtraValue(s.supplier_id, quota.quota_id) }}
                  </td>
                </tr>
                <tr *ngIf="!quota.suppliers || !quota.suppliers.length">
                  <td colspan="3" style="padding: 6px 8px; color: #777">
                    No suppliers for this quota
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="margin-top: 8px; color: #666; font-size: 0.85rem">
              Tip: Open the <strong>Suppliers</strong> tab to see full supplier
              details and click a supplier to expand details there.
            </div>
          </div>
        </details>
      </article>
    </ng-container>
  </div>
</div>

<div
  class="tab-panel"
  *ngIf="activeTab === 'redistributionAdditions'"
  role="tabpanel"
>
  <h3>Redistribution Additions</h3>
  We added an extra countr for the following quota/suppliers:
  <ng-container *ngFor="let redistribution of redistributionAdditions">
    <div>
      Supplier ID: {{ redistribution.supplierId }} Quota ID:
      {{ redistribution.quotaId }}
    </div>
  </ng-container>
</div>

<div class="tab-panel" *ngIf="activeTab === 'raw'" role="tabpanel">
  <h3>Raw JSON</h3>
  <pre class="raw-json">{{ response.report }}</pre>
</div>
